import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

export interface MultiselectOpenableTemplateContext {
  selectedItems: string[];
  onDone: () => void;
  onClose: () => void;
  onStart: () => void;
}

@Component({
  selector: 'app-multiselect-openable-button',
  templateUrl: './multiselect-openable-button.component.html',
  standalone: false,
})
export class MultiselectOpenableButtonComponent implements OnInit, OnChanges {
  isOpen = false;

  @Input()
  openableTemplate: TemplateRef<any>;

  @Input()
  buttonTranslationKey: string;

  @Input()
  selectedItems: string[];

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onDone = new EventEmitter();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onLoading = new EventEmitter<boolean>();

  @Output()
  buttonAction = new EventEmitter();

  hidden: boolean;

  context: MultiselectOpenableTemplateContext;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.context = {
      selectedItems: this.selectedItems,
      onDone: this.actionDone.bind(this),
      onClose: this.setHidden.bind(this),
      onStart: this.actionStarted.bind(this),
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('selectedItems' in changes) {
      this.context = { ...this.context, selectedItems: this.selectedItems };
    }
  }

  openClick(event: MouseEvent): void {
    event.stopPropagation();

    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.buttonAction.emit();
    }
  }

  close(): void {
    this.isOpen = false;
  }

  setHidden(): void {
    this.hidden = true;
    this.cd.detectChanges();
  }

  actionStarted(): void {
    this.onLoading.emit(true);
  }

  actionDone(): void {
    this.onLoading.emit(false);
    this.isOpen = false;
    this.onDone.emit();
    this.hidden = false;
  }

  buildTranslationKey(relativeKey: string): string {
    return `multiselect.${relativeKey}`;
  }
}
